import { render, staticRenderFns } from "./SplitIdSummary.vue?vue&type=template&id=b3b186f6&scoped=true&"
import script from "./SplitIdSummary.vue?vue&type=script&lang=js&"
export * from "./SplitIdSummary.vue?vue&type=script&lang=js&"
import style0 from "./SplitIdSummary.vue?vue&type=style&index=0&id=b3b186f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b186f6",
  null
  
)

export default component.exports